































import Vue from "vue";
import Member from "@/components/shared/member/Member.vue";
import {
  getLeadershipMembers,
  getBoardMembers,
} from "@/resources/content/team.ts";

export default Vue.extend({
  name: "Memeber",
  components: {
    Member,
  },
  data() {
    return {
      membersLeadership: <any>[],
      membersBoard: <any>[],
    };
  },
  created() {
    this.membersLeadership = getLeadershipMembers();
    this.membersBoard = getBoardMembers();
  },
});
